import React, { useEffect, useState } from "react"
import {
  Card,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import UpdateTable from "../../../components/Common/UpdatedTable"
import {
  downloadAccGroupSummary,
  downloadDayBook,
  fetchFinanceGroupSummary,
} from "../../../services/finance/finance"
import moment from "moment"
import { useLocation, useNavigate } from "react-router-dom"
import closeIcon from "../../../assets/icons/close.svg"
import NumberFormat from "../../../utils/numberFormat"
import { createSelector } from "reselect"
import { useSelector } from "react-redux"
import GroupSummaryFilter from "./filter"
import { toastError } from "../../../helpers/msg_helper"
import arrow from "../../../assets/icons/arrow.svg"

const BankCashReport = ({ fromDashboard }) => {
  const location = useLocation()

  const pathName =
    location?.pathname == "/finance/group-summary-report"
      ? "Group Summary"
      : location?.pathname == "/finance/cash-book-report"
      ? "Cash Book"
      : location?.pathname == "/finance/bank-book-report"
      ? "Bank Book"
      : location?.pathname == "/finance/purchase-register"
      ? "Purchase Register"
      : location?.pathname == "/finance/sales-register"
      ? "Sales Register"
      : ""

  const companyname = localStorage.getItem("companyname")
  document.title = `${pathName || "Account Book"}${
    companyname ? ` | ${companyname}` : "MEP -Hub"
  }`

  const selectLoginState = state => state.Login
  const LoginProperties = createSelector(selectLoginState, login => ({
    loggedUser: login.loggedUser,
  }))

  const { loggedUser } = useSelector(LoginProperties)
  const desimalrange = localStorage.getItem("desimalrange")

  const locations = useLocation();
  const crumb = locations?.state?.menuLabel || ""

  console.log(`desimalrange`, desimalrange)

  const navigate = useNavigate()
  const [search, setSearch] = useState("")
  const [page, setPage] = useState(1)
  const [fetchedData, setFetchedData] = useState()
  const [groupedData, setGroupData] = useState()
  const [dateFrom, setDatefrom] = useState("")
  const [dateTo, setDateto] = useState("")
  const [acc, setAcc] = useState(
    pathName == "Cash Book"
      ? [6]
      : pathName == "Bank Book"
      ? [5, 15]
      : pathName == "Purchase Register"
      ? [29]
      : pathName == "Sales Register"
      ? [26]
      : 0
  )

  console.log(`acc`, acc)

  const [viewData, setViewData] = useState()
  const [modal, setModal] = useState(false)
  const [dataPerPage, setDataPerPage] = useState(1000)

  const toggle = () => setModal(!modal)

  const [voucherTypeId, setVoucherTypeId] = useState("")

  useEffect(() => {
    setAcc(
      pathName == "Cash Book"
        ? [6]
        : pathName == "Bank Book"
        ? [5, 15]
        : pathName == "Purchase Register"
        ? [29]
        : pathName == "Sales Register"
        ? [26]
        : 0
    )
    setPage(1)
  }, [pathName])

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responce = await fetchFinanceGroupSummary({
          params: `${search ? `&searchText=${search}` : "&searchText"}${
            page ? `&page=${page}` : ""
          }${`&sortOrder=asc`}${
            acc && acc.length ? acc.map(id => `&group_id[]=${id}`).join("") : ""
          }${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}${dateFrom ? `&start_date=${dateFrom}` : ""}${
            dateTo ? `&end_date=${dateTo}` : ""
          }`,
        })

        const groupedLedgers = Object.values(
          responce?.ledgers.reduce((acc, ledger) => {
            if (!acc[ledger.group_name]) {
              acc[ledger.group_name] = {
                group_name: ledger.group_name,
                ledgers: [],
                totalCurrentDebit: 0,
                totalCurrentCredit: 0,
              }
            }

            acc[ledger.group_name].ledgers.push({
              ...ledger,
              id: ledger.ledger_id,
              group_name: ledger.group_name,
            })

            // 🔹 Add to totals
            acc[ledger.group_name].totalCurrentDebit += ledger.currentDebit || 0
            acc[ledger.group_name].totalCurrentCredit +=
              ledger.currentCredit || 0

            return acc
          }, {})
        )

        console.log(`groupedLedgers`, groupedLedgers)

        setFetchedData(responce)
        setGroupData(groupedLedgers)
      } catch (err) {
        toastError(err?.message)
        setFetchedData(null)
        setGroupData([])
      }
    }
    if (acc != undefined && acc !== "" && acc !== 0) {
      fetchData()
    }
  }, [
    // page,
    // search,
    // location,
    dateFrom,
    dateTo,
    // voucherTypeId,
    // dataPerPage,
    acc,
  ])
  const handleVoucherTypeChange = id => {
    setVoucherTypeId(id)
    setPage(1)
  }

  // ${dateFrom ? `&start_date=${dateFrom}` : ""}${
  //   dateTo ? `&end_date=${dateTo}` : ""
  // }

  const handleView = item => {
    setViewData(item)
    toggle()
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const handleScroll = e => {
    console.log("scroll event fired", e.target.scrollTop)
    const { scrollTop, scrollHeight, clientHeight } = e.target

    console.log(
      `scrollTop, scrollHeight, clientHeight`,
      e,
      scrollTop,
      scrollHeight,
      clientHeight
    )

    if (scrollHeight - scrollTop <= clientHeight + 50) {
      // near bottom
      if (page < fetchedData?.last_page) {
        setPage(prev => prev + 1)
      }
    }
  }

  const columns = [
    {
      label: "Particulars",
      renderCell: item => (
        <div
          //   onClick={() =>
          //     navigate(`/finance-ledger-acc`, {
          //       state: item,
          //     })
          //   }
          className="pointer fw-bold"
        >
          {item?.group_name}
        </div>
      ),
    },

    {
      label: <div className="text-end pe-5">Debit (AED)</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(item?.totalCurrentDebit, desimalrange, desimalrange)}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-3">Credit (AED)</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(item?.totalCurrentCredit, desimalrange, desimalrange)}
        </div>
      ),
    },
  ]
  const viewColumn = [
    {
      label: "Group Name",
      renderCell: item => (
        <div
          onClick={() =>
            navigate(`/finance/monthly-report/${item?.id}`, {
              state: {
                item,
                startDate: dateFrom,
                endDate: dateTo,
              },
            })
          }
          className="pointer fw-bold fs-13 ps-2"
        >
          {item?.ledger_name}
          <span className="ps-1">
            <img src={arrow} alt="" width="7" />
          </span>
        </div>
      ),
    },
    {
      label: "Amount",
      label: "Amount",
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(Number(item?.currentDebit), desimalrange, desimalrange)}
          {/* AED */}
        </div>
      ),
    },
    {
      label: "Amount",
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.currentCredit),
            desimalrange,
            desimalrange
          )}{" "}
          {/* AED */}
        </div>
      ),
    },
  ]

  const handlePaginate = page => {
    setPage(page)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }

  const handleDateChange = (fromdate, todate) => {
    setDatefrom(fromdate)
    setDateto(todate)
    setPage(1)
  }

  const handleAccChange = data => {
    setAcc([data])
    setPage(1)
  }
  return (
    <React.Fragment>
      <div className={`page-content ${fromDashboard ? "pt-0" : ""}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            {!fromDashboard ? (
              <>
                <Breadcrumbs
                  title="Finance"
                  breadcrumbObject={[
                    { title: "Finance", link: "/finance" },
                    { title: "Reports", link: "/finance" },
                    { title: crumb || "Account Book", link: "/finance" },
                    { title: pathName, link: "" },
                  ]}
                />
              </>
            ) : (
              <></>
            )}
            <>
              <div className="me-2">
                <span
                  id={`PopoverLegacy-1`}
                  className="px-2 mb-3 btn btn-primary"
                >
                  Download
                </span>
              </div>
              <UncontrolledPopover
                placement="bottom"
                target={`PopoverLegacy-1`}
                trigger="legacy"
              >
                <PopoverBody>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadAccGroupSummary({
                        params: `${
                          search ? `&searchText=${search}` : "&searchText"
                        }${page ? `&page=${page}` : ""}${
                          acc && acc.length
                            ? acc.map(id => `&group_id[]=${id}`).join("")
                            : ""
                        }${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}${dateFrom ? `&start_date=${dateFrom}` : ""}${
                          dateTo ? `&end_date=${dateTo}` : ""
                        }${"&download=pdf"}`,
                        type: "pdf",
                        fileName: `${pathName}.pdf`,
                      })
                    }
                  >
                    PDF
                  </div>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadAccGroupSummary({
                        params: `${
                          search ? `&searchText=${search}` : "&searchText"
                        }${page ? `&page=${page}` : ""}${
                          acc && acc.length
                            ? acc.map(id => `&group_id[]=${id}`).join("")
                            : ""
                        }${dataPerPage ? `&sizePerPage=${dataPerPage}` : ""}${dateFrom ? `&start_date=${dateFrom}` : ""}${
                          dateTo ? `&end_date=${dateTo}` : ""
                        }${"&download=excel"}`,
                        type: "excel",
                        fileName: `${pathName}.xlsx`,
                      })
                    }
                  >
                    Excel
                  </div>
                </PopoverBody>
              </UncontrolledPopover>
            </>
          </div>
          <Card
            className={`me-2 px-2 pb-2 ${
              fromDashboard ? "dash-table-bg ps-0 pb-0 finance-table-nav" : ""
            }`}
          >
            {!fromDashboard ? (
              <>
                <GroupSummaryFilter
                  handleSearchChange={handleSearchChange}
                  handleDateChange={handleDateChange}
                  handleAccChange={handleAccChange}
                  isImport={false}
                  isGroup={pathName == "Group Summary" ? true : false}
                  //   handleVoucherTypeChange={handleVoucherTypeChange}
                />
                <hr className="table-divide" />
              </>
            ) : (
              <div></div>
            )}
            {groupedData?.length ? (
              <Row className="mt-2 ever-rise-table accTable">
                <Col
                  xs={12}
                  // className="vh-60"
                >
                  <div
                    className="scrollable-table-container"
                    style={{ height: "60vh", overflowY: "auto" }}
                    onScroll={handleScroll}
                  >
                    {groupedData?.length && (
                      <UpdateTable
                        className="mt-5"
                        nodes={groupedData}
                        // paginate={fetchedData}
                        CurrentPage={page}
                        columns={columns}
                        subColumn={viewColumn}
                        subName={"ledgers"}
                        subHeader={false}
                        expand={true}
                        handlePagination={handlePaginate}
                        // handleSizePerPage={handleSizePerPageChange}
                        // hidePaginate={true}
                        tableWidth="50% 25% 25%"
                        mobileWidth="80% 40% 40%"
                      />
                    )}
                  </div>
                </Col>
                <Row className="mt-2 fw-bold">
                  <Col lg={6}>Grand Total</Col>
                  <Col lg={3} className="text-end pe-5">
                    {NumberFormat(
                      Math.abs(Number(fetchedData?.groupDebit || 0)),
                      desimalrange,
                      desimalrange
                    )}
                  </Col>
                  <Col lg={3} className="text-end pe-5">
                    {NumberFormat(
                      Math.abs(Number(fetchedData?.groupCredit || 0)),
                      desimalrange,
                      desimalrange
                    )}
                  </Col>
                </Row>
              </Row>
            ) : (
              <div className="d-flex justify-content-center pt-5">
                {pathName == "Group Summary" ? "Please Select Group" : ""}
              </div>
            )}
          </Card>
        </div>
      </div>
      {/* <Modal isOpen={modal} toggle={toggle} size="lg" unmountOnClose={false}>
        <>
          <ModalHeader className="custom-modal-header">
            <div className="d-flex justify-content-between">
              <h5 className="ms-2">Details</h5>
              <img
                src={closeIcon}
                alt=""
                onClick={toggle}
                width="10"
                role="button"
              />
            </div>
          </ModalHeader>
          <ModalBody>
            <Row className="mt-2 ever-rise-table accTable">
              <Col xs={12}>
                {viewData?.journal_entry_details && (
                  <UpdateTable
                    className="mt-5"
                    nodes={viewData?.journal_entry_details}
                    columns={viewColumn}
                    handilpagedrop={false}
                    tableWidth="20% 20% 20% 20% 20%"
                    mobileWidth="40% 40% 40% 40% 40%"
                  />
                )}
              </Col>
            </Row>
          </ModalBody>
        </>
      </Modal> */}
    </React.Fragment>
  )
}

export default BankCashReport
